export async function invokeCodedFormFlowAsync(formFlowDefinition, input) {
    let formFlowResult;
    if (input) {
        const args = extractArguments(formFlowDefinition, input);
        formFlowResult = await formFlowDefinition.invokeCodedFormFlow(...args);
    }
    else {
        formFlowResult = await formFlowDefinition.invokeCodedFormFlow();
    }
    return extractOutputResult(formFlowDefinition, formFlowResult);
}
function* extractArguments(formFlowDefinition, input) {
    var _a;
    for (const parameter of (_a = formFlowDefinition.Parameters) !== null && _a !== void 0 ? _a : []) {
        yield parameter.Name in input ? input[parameter.Name] : undefined;
    }
}
function extractOutputResult(formFlowDefinition, formFlowResult) {
    var _a;
    if (!((_a = formFlowDefinition.OutParameters) === null || _a === void 0 ? void 0 : _a.length)) {
        return undefined;
    }
    if (formFlowDefinition.OutParameters.length === 1) {
        const parameterName = formFlowDefinition.OutParameters[0].Name;
        // Check if the single output is already wrapped in an object by the coded form flow
        if (typeof formFlowResult !== "object" || formFlowResult === null || !(parameterName in formFlowResult)) {
            const result = {};
            result[parameterName] = formFlowResult;
            return result;
        }
    }
    return formFlowResult;
}
